module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.buttons) ? _c('div', {
    staticClass: "add-buttons"
  }, [_c('div', {
    staticClass: "actions"
  }, _vm._l((_vm.buttons), function(button) {
    return (_vm.can(button)) ? _c('div', {
      key: button.name,
      staticClass: "action"
    }, [(button.action == 'link') ? _c('router-link', {
      attrs: {
        "to": button.href
      }
    }, [(button.show) ? _c('button', {
      staticClass: "btn",
      class: button.classes,
      attrs: {
        "disabled": button.disabled,
        "data-action": button.action,
        "id": button.action
      },
      on: {
        "click": function($event) {
          return _vm.action(button)
        }
      }
    }, [(button.icon) ? _c('span', {
      staticClass: "icon"
    }, [(button.icon == 'arrow_left') ? _c('img', {
      attrs: {
        "src": require("../../../assets/arrow_left.svg")
      }
    }) : _vm._e(), _vm._v(" "), (button.icon == 'arrow_right') ? _c('img', {
      attrs: {
        "src": require("../../../assets/arrow_right.svg")
      }
    }) : _vm._e()]) : _c('div', [_vm._v("\n            " + _vm._s(_vm.$t("ui.button." + button.action)) + "\n          ")])]) : _vm._e()]) : (button.action != 'link') ? _c('button', {
      staticClass: "btn",
      class: button.classes,
      attrs: {
        "disabled": button.disabled,
        "data-action": button.action,
        "id": button.action
      },
      on: {
        "click": function($event) {
          return _vm.action(button)
        }
      }
    }, [(button.icon) ? _c('span', {
      staticClass: "icon"
    }, [(button.icon == 'import') ? _c('img', {
      attrs: {
        "src": require("../../../assets/import.svg")
      }
    }) : _vm._e()]) : _c('div', [_vm._v("\n          " + _vm._s(_vm.$t("ui.button." + button.action)) + "\n        ")])]) : _vm._e()], 1) : _vm._e()
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3512cd80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/AddButton.vue
// module id = 1865
// module chunks = 0